import React from "react";
import { PersistData } from "../middleware/persistDataMiddleware";
import {
    PERSIST_DATA,
    CUSTOMER_ID,
    CONTRACTOR_ID,
    CREATE_ANOTHER,
    IS_EDITABLE_WARRANTY,
    SEARCH_ITEM,
    COPY_WARRANTY_DATA,
} from "../constants/storageKeys";
import * as API from "../../config.json";
import { validationCheck } from "./validation";
import ConstantFile from "../constants/constantFile";
// eslint-disable-next-line @typescript-eslint/no-var-requires
const deepEqual = require("deep-equal");
/**
 * redirect to ccz url page
 * @category Utils
 */

export const imagePathurl = (): string => `${API.CDN_PATH}assets/images/`;

export const redirectToCCZ = (): void => {
    window.location.href = `${API["CONFIG"].cczLink}?redirectURL=${API["OKTA_CONFIG"].loginUrl}`;
};

export const dateTimeFormatter = (date) => {
    const d = new Date(date),
        hour = d.getHours() > 12 ? "" + (d.getHours() - 12) : "" + d.getHours(),
        minutes = "" + d.getMinutes(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
    const format = (value) => (value.length < 2 ? "0" + value : value);
    const getMeridiem = d.getHours() < 12 ? "AM" : "PM";
    const responseDate = [format(month), format(day), year].join("/");
    const responseTime = ` ${format(hour)}:${format(minutes)} ${getMeridiem}`;
    return responseDate + responseTime;
};

/**
 * @category Utils
 * @param {string} date - Date in string formate
 */
export const timeFormatter = (date) => {
    const d = new Date(date),
        hour = d.getHours() > 12 ? "" + (d.getHours() - 12) : "" + d.getHours(),
        minutes = "" + d.getMinutes();
    const format = (value) => (value.length < 2 ? "0" + value : value);
    const getMeridiem = d.getHours() < 12 ? "AM" : "PM";
    const responseTime = `${format(hour)}:${format(minutes)} ${getMeridiem}`;
    return responseTime;
};

/**
 * @category Utils
 * @param {string} date
 */
export const dateFormatter = (date) => {
    const d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
    const format = (value) => (value.length < 2 ? "0" + value : value);
    return [format(month), format(day), year].join("/");
};

/**
 * @category Utils
 * @param {object} obj
 * @param {string} key
 */
export const valueResolver = (obj: any, key: any) => {
    const valKey = key.split(".");
    if (!obj) {
        return;
    }
    if (valKey.length === 1) {
        return obj[valKey[0]] || "";
    }
    return valueResolver(obj[valKey[0]], valKey.splice(1).join("."));
};

/**
 * @category Utils
 * @param {object} formData
 * @param {object} validationObject
 */
export const buildingAddressValidation = (formData, validationObject) => {
    let utilObject = [];
    validationObject["condition"].forEach((condition) => {
        const value = valueResolver(formData, condition);
        utilObject = value === "SF" ? validationObject["SF"] : validationObject["Others"];
    });
    let count = 0;
    utilObject.forEach((util) => {
        if (valueResolver(formData, util.validatePath) && valueResolver(formData, util.validatePath).length > 0) {
            count++;
        }
    });
    return count === utilObject.length;
};

export const getDataFromStore = (dataSources: any, dataObj: any, stateValue: any) => {
    const { id, value, buildingAddress, mailAddress } = dataObj;

    let globalDataSource;
    if (id.includes("mailWarrantyInfo")) {
        globalDataSource = mailAddress;
    } else {
        globalDataSource = buildingAddress;
    }

    let valueupdated = stateValue;
    for (let i = 0; i < dataSources.length; i++) {
        const splitArr = dataSources[i].nodes.split("|");
        for (let j = 0; j < splitArr.length; j++) {
            valueupdated = mapDataSourceToReduxStore(globalDataSource, splitArr[j]);
        }
    }
    if (value !== valueupdated) {
        return valueupdated;
    }
};
/**
 * @category Utils
 * @param {object} obj
 * @param {string} key
 * @description Resolve the value from redux store the by using datasource
 */
export const mapDataSourceToReduxStore = (reduxStoreObject: any, key: any) => {
    const dataSourceKey = key.split(".");
    if (!reduxStoreObject) {
        return;
    } else if (dataSourceKey.length === 1) {
        if (reduxStoreObject[dataSourceKey[0]] == "undefined") return reduxStoreObject;
        return reduxStoreObject[dataSourceKey[0]];
    } else return mapDataSourceToReduxStore(reduxStoreObject, dataSourceKey.splice(1).join("."));
};

export const resetNodeInFormData = (formData: any, resetNode: any, resetValue?: any) => {
    const dataSourceKey = resetNode.split(".");
    if (!formData) {
        return;
    } else if (dataSourceKey.length === 1) {
        resetValue ? (formData[dataSourceKey[0]] = resetValue) : (formData[dataSourceKey[0]] = undefined);
    } else return resetNodeInFormData(formData[dataSourceKey[0]] ?? {}, dataSourceKey.splice(1).join("."), resetValue);
};

export const errorCalculator = (menuKeys, enumOption, errorResponse) => {
    let navMenuCounts = {};
    menuKeys.map((menu) => {
        let count = 0;
        for (const i in errorResponse) {
            if (i.includes(menu[enumOption]) && !i.includes("saveTemplate_templates")) {
                count = count + 1;
            }
            navMenuCounts = { ...navMenuCounts, [menu[enumOption]]: count };
        }
    });
    return navMenuCounts;
};
export const getBOErrorNav = (errorResponse) => {
    let isBuildingAndOwnerErrorExist = false;
    let isProjectDetailsErrorExist = false;
    for (const i in errorResponse) {
        if (i.indexOf("buildingAndOwnerInfo") > -1) {
            isBuildingAndOwnerErrorExist = true;
        }
        if (i.indexOf("projectDetails") > -1) {
            isProjectDetailsErrorExist = true;
        }
    }
    return !isBuildingAndOwnerErrorExist && isProjectDetailsErrorExist ? "PD" : "BO";
};
function returnBoolValue(value: string): boolean {
    if (value === "true") {
        return true;
    } else {
        return false;
    }
}

export const setCCzPopup = (confirm) => localStorage.setItem("popupCheckbox", confirm);
export const getCCzPopup = (): boolean => {
    const value = localStorage.getItem("popupCheckbox");
    return returnBoolValue(value);
};
export const setDashboardPopup = (confirm) => localStorage.setItem("dashboardpopupCheckbox", confirm);
export const getDashboardPopup = (): boolean => {
    const value = localStorage.getItem("dashboardpopupCheckbox");
    return returnBoolValue(value);
};
const windowBeforeUnload = (e) => {
    const confirmationMessage = "You will loose information on refresh. Do you still want to leave?";
    e.returnValue = confirmationMessage;
    return window.confirm(confirmationMessage);
};
export const removeWindowBeforeUnload = () => {
    window.removeEventListener("beforeunload", windowBeforeUnload);
};
export const addWindowBeforeUnload = () => {
    window.addEventListener("beforeunload", windowBeforeUnload);
};
const handleLeavePage = (obj) => {
    const requestURL = sessionStorage.getItem("requestURL");
    const persist = sessionStorage.getItem("persist");
    const createAnother = sessionStorage.getItem(CREATE_ANOTHER);
    const copyData = sessionStorage.getItem(COPY_WARRANTY_DATA);
    const lastSearchedItem = sessionStorage.getItem(SEARCH_ITEM);
    const customer_id = sessionStorage.getItem("customer_id");
    if (
        !(
            /homenotloggedin|homeloggedin|callback/.test(window.location.href) ||
            localStorage.getItem("skipSessionClear")
        )
    ) {
        sessionStorage.clear();
    }
    if (requestURL) {
        sessionStorage.setItem("requestURL", requestURL);
    }
    if (persist) {
        sessionStorage.setItem("persist", persist);
    }
    if (customer_id) {
        sessionStorage.setItem("customer_id", customer_id);
    }
    if (createAnother) {
        sessionStorage.setItem(CREATE_ANOTHER, createAnother);
    }
    if (copyData) {
        sessionStorage.setItem(COPY_WARRANTY_DATA, copyData);
    }
    if (lastSearchedItem) {
        sessionStorage.setItem(SEARCH_ITEM, lastSearchedItem);
    }
};
export const removeSessionBeforeUnload = () => {
    window.removeEventListener("beforeunload", handleLeavePage);
};
export const addSessionBeforeUnload = () => {
    window.addEventListener("beforeunload", handleLeavePage);
};
/**
 * verify element in viewport
 * @param {HTMLElement} element
 * @category Utils
 */
export const isInViewport = (element: HTMLElement) => {
    const bounding = element.getBoundingClientRect();
    const formController = document.getElementById("form-controller-container").offsetHeight || 0;
    const legacyFooter = document.getElementById("legacy-footer-container").offsetHeight || 0;
    const footerHeight = formController + legacyFooter;
    return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <=
            (window.innerHeight - footerHeight || document.documentElement.clientHeight - footerHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

/**
 * OnEnter on focused / active element
 * will trigger onclick method of that element
 * @param {KeyboardEvent} e
 * @category Utils
 */
export const handleEnter = (e: React.KeyboardEvent<HTMLElement>) => {
    const code = e.charCode ? e.charCode : e.keyCode;
    if (code === 13) {
        const activeElement: HTMLElement = document.activeElement as HTMLElement;
        activeElement && activeElement.click();
    }
};

export const JSONGenerator = (reviewDate) => {
    const newObj = {};
    for (const property in reviewDate) {
        if (typeof reviewDate[property] == "object" && !Array.isArray(reviewDate[property])) {
            newObj[property] = {};
            for (const subProperty in reviewDate[property]) {
                if (
                    typeof reviewDate[property][subProperty] == "object" &&
                    !Array.isArray(reviewDate[property][subProperty])
                ) {
                    for (const subProperty1 in reviewDate[property][subProperty]) {
                        newObj[property][subProperty1] = reviewDate[property][subProperty][subProperty1];
                    }
                    // } else if (Array.isArray(reviewDate[property][subProperty])) {
                    //     newObj[property][subProperty] = reviewDate[property][subProperty].join(" ").trim();
                } else {
                    newObj[property][subProperty] = reviewDate[property][subProperty];
                }
            }
        } else {
            newObj[property] = reviewDate[property];
        }
    }
    return newObj;
};

export const validateEmptyForm = (formData, utilObject) => {
    let count = 0;
    utilObject.map((util) => {
        count +=
            typeof valueResolver(formData, util.validatePath) === "number"
                ? valueResolver(formData, util.validatePath).toString().length
                : valueResolver(formData, util.validatePath)
                ? valueResolver(formData, util.validatePath).length
                : 0;
    });
    return count > 0 ? 1 : 0;
};

/**
 * Get cookie value
 * @param {string} name - Cookie name
 * @category Utils
 */
function getCookie(name: string) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
}

/**
 * Store the value in session storage
 * @param {string} name
 * @param {any} value
 */
export function setSessionValue(name: string, value: any): void {
    sessionStorage.setItem(name, JSON.stringify(value));
}

/**
 * Get Value from session storage
 * @param {string} name
 * @category Utils
 */
export function getSessionValue(name: string): any {
    const value = sessionStorage.getItem(name);
    if (value) {
        try {
            return JSON.parse(value);
        } catch (e) {
            return null;
        }
    }
    return null;
}

export const getQueryString = (field, url) => {
    const reg = new RegExp(`[?&]${field}=([^&#]*)`, "i");
    const string = reg.exec(url);
    return string ? string[1] : null;
};

/**
 * get customerID from query param string
 * @return {string} customerID
 * @category Utils
 */
export const getCustomerIDFromURL = (): string => {
    // const urlParams = new URLSearchParams(window.location.search);
    // return urlParams.get("customerID");
    return getQueryString("customerID", window.location.href);
};

export const getImpersonationParamFromURL = (): string => {
    // const urlParams = new URLSearchParams(window.location.search);
    // return urlParams.get("impersonatedBy");
    return getQueryString("impersonatedBy", window.location.href);
};

export const handleRedirectAuth = () =>{
    const cczlink = `${API["CONFIG"].cczLink}`;
    removeWindowBeforeUnload();
    window.open(cczlink, "_self");
}
/**
 * Get Persist Data from local storage
 * @category Utils
 * @return {PersistData} Persist session cookie data
 */
export const getPersistData = (): PersistData => getSessionValue(PERSIST_DATA);

/**
 * Store PersistData in session storage
 * @param {PersistData} data
 * @category Utils
 */
export const setPersistData = (data: PersistData): void => setSessionValue(PERSIST_DATA, data);

/**
 * Store only customer ID in session cookie
 * @category Utils
 */
export const storeCustomerID = (): void => {
    const customerID = getCustomerIDFromURL();
    if (customerID) {
        // document.cookie = `${CUSTOMER_ID}=${customerID}`;
        setSessionValue(CUSTOMER_ID, customerID);
    }
};

export const getAllParameters = (userInfo) => {
    const customerId = getCustomerIDFromStore(false);
    let path = customerId ? `/?customerID=${customerId}` : "/";
    if(userInfo && userInfo.isAdmin) {
        path = "/?provider=okta"
    }
    return path;
}
export const getParameterByName = (name, url) => {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return results[2];
};
export const checkForReadOnly = (cosntant, isSubmitted) => {
    const isReadOnly = getSessionValue(IS_EDITABLE_WARRANTY);
    if (isReadOnly) {
        return true;
    }
    if (cosntant && cosntant.onlyForSubmitted && cosntant.readOnly) {
        if (isSubmitted) {
            return true;
        } else {
            return false;
        }
    } else if (cosntant && !cosntant.onlyForSubmitted && cosntant.readOnly) {
        return true;
    }
    return false;
};

export const checkForPriceChanges = (cosntant, isSubmitted) => {
    if (cosntant && cosntant.onlyForSubmitted && cosntant.priceChangeCheck) {
        if (isSubmitted) {
            return true;
        } else {
            return false;
        }
    } else if (cosntant && !cosntant.onlyForSubmitted && cosntant.priceChangeCheck) {
        return true;
    }
    return false;
};
/**
 * get the customerID from the cookie
 * @param {boolean} isEncode
 * @category Utils
 */
export const getCustomerIDFromStore = (isEncode: boolean): string => {
    const custId = getSessionValue(CUSTOMER_ID);
    return custId ? (isEncode ? encodeURIComponent(custId) : custId) : "";
};
/**
 * get the contratorID from the cookie
 * @category Utils
 */
export const getContractorIDFromStore = () => {
    const custId = getSessionValue(CONTRACTOR_ID);
    return custId ? custId : "";
};

/**
 * @category Utils
 * @param {object} errorSchema
 * @param {object} schema
 * @param {string} id
 * @param {boolean} needDataValidator
 */
export const getPriceCheckDetails = (errorSchema: any, schema: any, id: string, needDataValidator?: boolean): any => {
    const { family } = schema.const;
    const IDlist = id.split("_");
    const fieldName = IDlist[IDlist.length - 1];
    const dataValidatorPath =
        errorSchema &&
        errorSchema.length &&
        errorSchema.filter((key) =>
            key.parentDependency ? key.key === fieldName && key.parentDependency === family : key.key === fieldName
        );
    const priceCheck =
        Array.isArray(dataValidatorPath) &&
        dataValidatorPath.length > 0 &&
        dataValidatorPath[0].value.filter((val) => val.validationType === "priceCheck");

    if (needDataValidator) {
        return { family, fieldName, priceCheck, dataValidatorPath };
    }
    return { family, fieldName, priceCheck };
};
const isCallPreventDefault = (value, type) => {
    const regSpclChar = /[\^<>&"()#%;+?]/;
    if (type === "number" || type === "integer") {
        if (type === "number") {
            if (value.split(".").length > 2) {
                return true;
            }
        }
        if (!((type === "number" && /^[.0-9]*$/.test(value)) || (type === "integer" && /^[0-9]*$/.test(value)))) {
            return true;
        }
    } else if (regSpclChar.test(value)) {
        return true;
    }
};
export const specialCharacterCheck = (e, fieldDetails, type): any => {
    const pastedData = e.clipboardData.getData("Text");
    if (isCallPreventDefault(pastedData, type)) {
        e.preventDefault && e.preventDefault();
        return false;
    }
};
export const dropCheck = (ev, type) => {
    const src = window.getSelection().toString();
    if ((src && isCallPreventDefault(src, type)) || src === "") {
        ev.preventDefault && ev.preventDefault();
        return false;
    }
};
export function loadGoogleMapAPI() {
    const googleMapUrl = API.CONFIG.googleMapUrl;
    const clientKey = API.CONFIG.googleMapClientKey;
    if (googleMapUrl && clientKey) {
        if (!document.getElementById("googlePlaces")) {
            const script = document.createElement("script");
            script.setAttribute("id", "googlePlaces");
            script.src = googleMapUrl + clientKey + "&libraries=places";
            document.getElementsByTagName("head")[0].appendChild(script);
        }
    }
}

export const preventSpecialCharacters = (evt) => {
    ["?", "<", ">", "&", '"', "(", ")", "#", "%", ";", "+"].includes(evt.key) && evt.preventDefault();
};

/**
 * Parse JSON string into object
 * @param {string | object} value
 */
export const parseObject = (value: any): any => {
    if (!value || typeof value === "object") return value;
    let parseValue;
    try {
        parseValue = JSON.parse(value);
    } catch (e) {
        parseValue = null;
    }
    return parseValue;
};

export const isDirty = (existingData: any, currentData: any) => {
    let isDirtyForm = false;
    switch(currentData.NavigationMenu) {
        case 'BO':
            isDirtyForm = !deepEqual(existingData.buildingAndOwnerInfo, currentData.buildingAndOwnerInfo);
            break;
        case 'PD':
            isDirtyForm = !deepEqual(existingData.projectDetails, currentData.projectDetails);
            break;
        case 'RP':
            isDirtyForm = !deepEqual(existingData.buildingAndOwnerInfo, currentData.buildingAndOwnerInfo)
                            || !deepEqual(existingData.projectDetails, currentData.projectDetails);
            break;
        default:
            isDirtyForm = false;
    }
    return isDirtyForm;
}

export const isOptionHidden = (value) => {
    const { hideSolarOptions } = ConstantFile;
    return hideSolarOptions.includes(value);
}

const isFound = (str, value) => {
    return str.split("_").find((x)=> x.toLowerCase() === value.toLowerCase());
}

const getUIOrder = (schema) => {
    const objProps = Object.keys(schema);
    for (let index = 0; index < objProps.length; index++) {
        const element = objProps[index];
        if(schema[element]["ui:order"]){
            return {option: element, uiOrder: schema[element]["ui:order"]}
        }
        
    }
}

const findFirstError = (schema, errors) => {
    const uiOrder = schema["ui:order"];
    if (uiOrder) {
        for (let index = 0; index < uiOrder.length; index++) {
            const order = uiOrder[index];
            const resultFound = errors.filter((err)=> isFound(err, order));
            if(resultFound.length === 1) {
                return resultFound;
            } else if(resultFound.length > 1) {
                let newSchema = schema[order];
                if(newSchema) {
                    const newUiOrder = newSchema["ui:order"];
                    if(!newUiOrder) {
                        const result = getUIOrder(newSchema)
                        if(result){
                            newSchema = newSchema[result.option];
                        }
                    }
                    return findFirstError(newSchema, errors);
                }
            }
        }
    } else {
        const uiOrder = Object.keys(schema);
        for (let index = 0; index < uiOrder.length; index++) {
            const order = uiOrder[index];
            const resultFound = Object.keys(errors).filter((err)=> isFound(err, order));
            if(resultFound.length) {
                return resultFound;
            }
        }
    }
}

export const getFirstError = (errorDetails, currentPage, uiSchema) => {
    const currentSchema = uiSchema.residentialWarrantyForm[currentPage];
    const error = findFirstError(currentSchema, Object.keys(errorDetails));
    return (error && error[0]) || Object.keys(errorDetails)[0];
}

export const getNextError = (id, errorDetails, currentPage, uiSchema) => {
    if(errorDetails && errorDetails[id]) {
        const clonedErrorDetails = JSON.parse(JSON.stringify(errorDetails));
        delete clonedErrorDetails[id];
        return getFirstError(clonedErrorDetails, currentPage, uiSchema);
    }
    return getFirstError(errorDetails, currentPage, uiSchema);
}

export const getOrderedErrors = (errorDetails, currentPage, uiSchema) => {
    const formErrors = [];
    if (errorDetails && Object.keys(errorDetails).length) {
        const clonedErrorDetails = JSON.parse(JSON.stringify(errorDetails));
            const id = getFirstError(clonedErrorDetails, currentPage, uiSchema);
            if(id.includes(currentPage)) formErrors.push(id);
            delete clonedErrorDetails[id];
            while (Object.keys(clonedErrorDetails).length > 0) {
                const nextId = getFirstError(clonedErrorDetails, currentPage, uiSchema);
                if(nextId.includes(currentPage)) formErrors.push(nextId);
                delete clonedErrorDetails[nextId];
            }
    }
    return formErrors;
}

export const getLastIdSubstring = (str, uiSchema) => {
    const ids = str.split("_");
    let schema = JSON.parse(JSON.stringify(uiSchema));
    for (let index = 1; index < ids.length; index++) {
        schema = schema[ids[index]];
    }
    for (const key in schema) {
        if (Object.hasOwnProperty.call(schema, key)) {
            const elm = schema[key];
            if(!!elm && elm.constructor === Object && Object.keys(elm).length > 1){
                return key;
            }
        }
    }
    return ids[ids.length - 1];
}

export const checkForReadOnlyChild = (schema, isSubmittedForm) => {
    const { properties } = schema;
    const elemnt = Object.keys(properties)[0];
    const schemaConst = properties[elemnt] ? properties[elemnt].const : {};
    return checkForReadOnly(schemaConst, isSubmittedForm)
}
const getSection = (errorFields) => {
    let section = errorFields[3];
    if(errorFields.includes('catalogofaccessories')){
        section = "Accessories"
    }
    return section;
}

export const getFormattedErrors = (errorDetails, uiSchema, isAdmin) => {
    const pages = {
        'buildingAndOwnerInfo': 'Building & Owner',
        'projectDetails': 'Project Details',
    };
    const errors = [];
    Object.keys(pages).forEach((currentPage)=>{
        const formErrors = getOrderedErrors(errorDetails, currentPage, uiSchema);
        for (let index = 0; index < formErrors.length; index++) {
            const errorFields = formErrors[index].split('_');
            const section = errorFields.length - 1 === 3 ? pages[currentPage] : getSection(errorFields);
            const fieldId = errorFields[errorFields.length - 1];
            const field = ConstantFile.errorFieldConst[fieldId] ? ConstantFile.errorFieldConst[fieldId] : fieldId;
            const isVarianceRequested = sessionStorage.getItem('isVarianceRequested') ? JSON.parse(sessionStorage.getItem('isVarianceRequested')) : false;
            
            const isSectionAllowed = section.toLowerCase() === 'accessories' || section.toLowerCase() === 'ownerInfo';
            const shouldSkipCheck = isAdmin || !isSectionAllowed; // Any one condition true will return true
            const canProceedToAddError = !isVarianceRequested || shouldSkipCheck; //

            // if( !isAdmin || section.toLowerCase() !== 'accessories'){ 
            // if( !isVarianceRequested || (!isAdmin || (section.toLowerCase() !== 'accessories'))) {
            if (canProceedToAddError) {
                errors.push({
                    page: pages[currentPage],
                    section: capitalize(section.replace(/([a-z](?=[A-Z]))/g, '$1 ')),
                    field: capitalize(field.replace(/([a-z](?=[A-Z]))/g, '$1 ')),
                });
            }
        }
    });
    return errors;
}

export const skipAdminValidation = (errors, isAdmin) => {
  const skip = [];
  const isVarianceRequested = sessionStorage.getItem('isVarianceRequested') ? JSON.parse(sessionStorage.getItem('isVarianceRequested')) : false;
  const continueAsAdminForError = sessionStorage.getItem('continueAsAdminForError') ? JSON.parse(sessionStorage.getItem('continueAsAdminForError')) : false;
// continueAsAdminForError
  if(isAdmin){
    const errs = Object.keys(errors);
    for (let index = 0; index < errs.length; index++) {
        const isAccessories = errs[index].split('_').includes('catalogofaccessories');
        const isRequiredEmailErr = errs[index].split('_').includes('email');
        // if(isVarianceRequested ) {
        //     skip.push(true)
        // } else if(isAccessories && !isVarianceRequested){
        //     skip.push(false);
        //     // skip.push(true);
        // } else {
        //     skip.push(false);
        // }
        if ( !continueAsAdminForError && (isAccessories || isRequiredEmailErr) && !isVarianceRequested) {
            skip.push(false);
        } else if (continueAsAdminForError && (isAccessories || isRequiredEmailErr) && !isVarianceRequested) {
            skip.push(true); // skip.push(true) --> This allows to override any error and proceed to next page
        } else if(isVarianceRequested && !continueAsAdminForError && (isAccessories || isRequiredEmailErr)) {
            skip.push(true);
        }else {
            skip.push(false);
        }
    }
  } else {
    if(!isAdmin && isVarianceRequested) {
        skip.push(true);
    }
  }
    return skip.length && !skip.includes(false);
};

export const capitalize = (s) => (s && s[0].toUpperCase() + s.slice(1)) || "";

export const checkSuperAdminAccess = (userInfo) => API.SUPER_ADMINS && API.SUPER_ADMINS.includes(userInfo.emailAddress.toLowerCase());

export const parseResponseData = (data) => {
    const checkoutItems = [];
    try {
        const { shoppingCartWarranties: items } = data;
        items.forEach((item) => {
            const {
                warrantyId,
                warrantyNumber,
                firstName,
                lastName,
                addressLine1,
                addressLine2,
                city,
                stateOrProvince,
                summaryPdfData,
                warrantyTypeName,
                postedDate,
                canGenerateReport,
                isVarianceWaiverRequest,
                varianceWaiverStatus,
                message
            } = item;
            checkoutItems.push({
                id: warrantyId,
                warrantyNumber: warrantyNumber,
                owner: {
                    firstName,
                    lastName,
                },
                buildingAddress: {
                    addressLine1,
                    addressLine2,
                    city,
                    stateOrProvince,
                },
                canGenerateFullReport: canGenerateReport,
                summaryPdfData,
                warrantyType: warrantyTypeName,
                postedDate,
                isVarianceWaiverRequest,
                varianceWaiverStatus,
                message
            });
        });
    } catch (err) {
        console.log(err);
    }
    return checkoutItems;
};